import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";

export default function AdminPreview() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/admin/articles/${id}`)
      .then((r) => setArticle(r.data))
      .catch(() => setNotFound(true));
  }, [id]);

  if (notFound) return <p className="text-enji py-20 text-center">Pratinjau tidak tersedia.</p>;
  if (!article) return <p className="text-sub py-20 text-center">Memuat pratinjau…</p>;

  return (
    <div data-testid="admin-preview-page" className="max-w-[720px] mx-auto py-8">
      <p className="text-[12px] uppercase tracking-[0.18em] font-semibold text-enji mb-4">Pratinjau Privat — {article.status}</p>
      <h1 className="font-serif text-4xl tracking-tight text-ink">{article.title}</h1>
      {article.excerpt && <p className="text-sub text-lg mt-4">{article.excerpt}</p>}
      <div className="reader mt-10" dangerouslySetInnerHTML={{ __html: article.content }} />
    </div>
  );
}

